import { Avatar, Menu, Stack, Text } from '@chakra-ui/react';
import { signOut } from '@mono/auth-react';
import { FC, useMemo } from 'react';
import useSession from '../session/useSession';

const ProfileInfo: FC = () => {
  const session = useSession();

  const { user } = useMemo(() => {
    return {
      user: session.data?.user,
    };
  }, [session.data?.user]);

  const initials = useMemo(() => {
    const source = user?.name || user?.email || '';
    if (!source) return '';
    return source
      .split(' ')
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }, [user?.name, user?.email]);

  if (!user) {
    return null;
  }

  return (
    <Menu.Root>
      <Menu.Trigger>
        <Avatar.Root size="sm" cursor={'pointer'}>
          {user.image ? (
            <Avatar.Image src={user.image} alt={user.name ?? 'User avatar'} />
          ) : (
            <Avatar.Fallback>{initials || '?'}</Avatar.Fallback>
          )}
        </Avatar.Root>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content>
          <Stack align="flex-start" gap="1" px="2" pb="2">
            <Text fontWeight="semibold">{user.name ?? 'Unknown user'}</Text>
            {user.email ? (
              <Text fontSize="sm" color="fg.muted">
                {user.email}
              </Text>
            ) : null}
          </Stack>
          <Menu.Separator my="2" />
          <Menu.Item
            value="logout"
            onClick={() => signOut()}
            fontWeight="medium"
            color="fg.muted"
            _hover={{ color: 'fg.default' }}
          >
            Logout
          </Menu.Item>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
};

export default ProfileInfo;
